import React, { useState } from 'react';
import type { StepsTooltip } from '../types';
import { StepsPreviewOverlay } from './StepsPreviewOverlay';

type Props = {
  data: StepsTooltip;
  /** 已填值时按钮隐藏（与 V1 upload/variable 一致：有内容就不再显示引导）。 */
  hidden?: boolean;
};

/**
 * steps 操作引导「查看教程」药丸按钮。
 *
 * V1 parity（`RichTextEditor/hooks.ts:795-797` + `index.tsx:553-566`）：
 *   - 按钮 **hover 不弹任何卡片**（V1 注释："已改为点击直接打开大图预览，hover 不再弹卡片"）
 *   - **点击**按钮 → 直接打开全屏大图预览 StepsPreviewOverlay
 *
 * 历史踩坑：曾误用 antd Popover trigger="hover" 弹 StepsTooltipCard 小卡，
 * 导致用户反馈「一 hover 就展开大图」——根上就不该 hover 弹，V1 早已废弃 hover 小卡。
 */
export const StepsTutorial: React.FC<Props> = ({ data, hidden }) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  if (hidden) return null;

  return (
    <>
      <span
        className="rte-tutorial-btn"
        data-node-type="steps-tutorial"
        onClick={() => setPreviewOpen(true)}
      >
        <i className="iconfont icon-tishi rte-tutorial-btn-icon" aria-hidden="true" />
        <span className="rte-tutorial-btn-text">查看教程</span>
      </span>
      {previewOpen ? (
        <StepsPreviewOverlay
          data={data}
          initialPlatformIndex={0}
          initialStepIndex={0}
          onClose={() => setPreviewOpen(false)}
        />
      ) : null}
    </>
  );
};
